// extracted by mini-css-extract-plugin
export default {"photo":"HeaderImageCard_photo__NUiCA"};